"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      defaultActiveKey = _ref.defaultActiveKey,
      className = _ref.className,
      variant = _ref.variant,
      activeKey = _ref.activeKey;

  var _useState = (0, _react.useState)(defaultActiveKey.toLowerCase()),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      tabsChildren = _useState4[0],
      setTabsChildren = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      activeChildren = _useState6[0],
      setActiveChildren = _useState6[1];

  var handleChangeTab = function handleChangeTab(value) {
    setActiveTab(value.toLowerCase());
  };

  (0, _react.useEffect)(function () {
    if (activeKey) {
      handleChangeTab(activeKey);
    }
  }, [activeKey]);
  (0, _react.useEffect)(function () {
    var showTabs = function showTabs() {
      if (children && children.length) {
        var clearTabs = children.filter(function (child) {
          return child;
        });
        var tabs = clearTabs.map(function (child) {
          return {
            eventKey: child.props.eventKey,
            title: child.props.title,
            children: child.props.children,
            disabled: child.props.disabled,
            icon: child.props.icon,
            placementIcon: child.props.placementIcon,
            styleIcon: child.props.styleIcon,
            onClick: child.props.onClickTab,
            leftContent: child.props.leftContent,
            rightContent: child.props.rightContent
          };
        });
        setTabsChildren(tabs);
        return tabs;
      } else {
        return [];
      }
    };

    showTabs();
  }, [children]);
  (0, _react.useEffect)(function () {
    var newActiveChildren = tabsChildren.filter(function (tab) {
      return tab.eventKey.toLowerCase() === activeTab.toLowerCase();
    });
    var newChildren = null;

    if (newActiveChildren.length == 1) {
      var _newActiveChildren = _slicedToArray(newActiveChildren, 1),
          element = _newActiveChildren[0];

      newChildren = element.children;
    }

    setActiveChildren(newChildren);
  }, [activeTab, tabsChildren]);

  var showTitle = function showTitle(tab) {
    var title = tab.title;

    if (tab.icon) {
      var Icon = tab.icon;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "d-flex justify-content-center align-items-center"
      }, tab.placementIcon === 'left' && /*#__PURE__*/_react.default.createElement(Icon, {
        style: _objectSpread({
          marginRight: 5
        }, tab.styleIcon)
      }), title, tab.placementIcon === 'right' && /*#__PURE__*/_react.default.createElement(Icon, {
        style: _objectSpread({
          marginLeft: 5
        }, tab.styleIcon)
      }));
    }

    if (tab.leftContent) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "d-flex justify-content-center align-items-center"
      }, tab.leftContent, title);
    }

    if (tab.rightContent) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "d-flex justify-content-center align-items-center"
      }, title, tab.rightContent);
    }

    return title;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tabs"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "tab-nav"
  }, tabsChildren.map(function (tab) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: tab.title,
      className: "".concat(activeTab === tab.eventKey.toLowerCase() ? 'active' : '', "\n                  ").concat(tab.disabled ? 'disabled' : ''),
      onClick: function onClick() {
        handleChangeTab(tab.eventKey);
        tab.onClick();
      }
    }, showTitle(tab));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "tabs-item ".concat(variant)
  }, activeChildren));
};

var _default = Tabs;
exports.default = _default;
Tabs.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.element),
  defaultActiveKey: _propTypes.default.string,
  className: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['close', 'primary', 'none']),
  activeKey: _propTypes.default.string
};
Tabs.defaultProps = {
  children: null,
  defaultActiveKey: '',
  className: '',
  variant: 'none',
  activeKey: ''
};